/* Seal'd Kitchen Co. — turns Pack variant pills into rich offer boxes.
   Dawn renders pack radios as: <input type=radio name="Pack-2" value="2-Pack — $49.99 (Save $10)"> <label for=id>...</label>
   We match any radio whose value looks like a pack (‘— $’) and rebuild its label. */
(function () {
  'use strict';

  function fmt(n) {
    var s = n.toFixed(2);
    return s.slice(-3) === '.00' ? n.toFixed(0) : s;
  }

  function labelFor(inp) {
    var l = inp.closest('label');
    if (l) return l;
    if (inp.id) {
      try { l = document.querySelector("label[for='" + CSS.escape(inp.id) + "']"); if (l) return l; } catch (e) {}
    }
    var sib = inp.nextElementSibling;
    while (sib) { if (sib.tagName === 'LABEL') return sib; sib = sib.nextElementSibling; }
    return null;
  }

  function packRadios() {
    var out = [];
    document.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      var v = inp.getAttribute('value') || '';
      if (/\u2014\s*\$[\d.]/.test(v)) out.push(inp);
    });
    return out;
  }

  function decorate() {
    var inputs = packRadios();
    if (!inputs.length) return;

    var isPress = false;
    inputs.forEach(function (inp) { if (/^single/i.test((inp.getAttribute('value') || '').trim())) isPress = true; });

    inputs.forEach(function (inp) {
      var label = labelFor(inp);
      if (!label) return;
      var raw = inp.getAttribute('value') || '';
      if (label.dataset.sealedDone === raw) return;

      var m = raw.match(/^(.*?)\s*\u2014\s*\$([\d.]+)(?:\s*\(Save \$([\d.]+)\))?/);
      if (!m) return;

      var name = m[1].trim();
      var price = parseFloat(m[2]);
      var save = m[3] ? parseFloat(m[3]) : 0;
      var qty = /single/i.test(name) ? 1 : (parseInt(name, 10) || 1);
      var per = price / qty;
      var compare = save ? price + save : 0;

      var caption;
      if (qty === 1) {
        caption = 'Ships $4.99 \u2014 or grab a 2-Pack and ship FREE';
      } else {
        caption = '$' + fmt(per) + ' each \u00b7 Ships FREE';
        if (isPress && qty === 2) caption += ' \u00b7 kitchen + camper';
        if (isPress && qty === 3) caption += ' \u00b7 our best deal';
        if (!isPress && qty === 2) caption += ' \u00b7 one home, one to-go';
        if (!isPress && qty === 4) caption += ' \u00b7 every snack drawer covered';
      }

      var fs = inp.closest('fieldset');
      if (fs) {
        fs.classList.add('sealed-pack-fieldset');
        if (isPress) fs.classList.add('sealed-has-single');
      }

      /* order chips: mark 2nd and last as popular / best value */
      label.dataset.sealedQty = qty;

      label.dataset.sealedDone = raw;
      label.classList.add('sealed-pack-label');
      label.innerHTML =
        '<span class="sealed-pack-title">' + name + (qty > 1 ? ' \u00b7 ' + qty + ' sealers' : '') + '</span>' +
        '<span class="sealed-pack-priceline">' +
          '<span class="sealed-pack-price">$' + price.toFixed(2) + '</span>' +
          (compare ? '<span class="sealed-pack-compare">$' + compare.toFixed(2) + '</span>' : '') +
          (save ? '<span class="sealed-pack-chip">SAVE $' + fmt(save) + '</span>' : '') +
        '</span>' +
        '<span class="sealed-pack-caption">' + caption + '</span>';
    });

    /* Assign ribbons per fieldset: most units = BEST VALUE, middle = MOST POPULAR */
    document.querySelectorAll('fieldset.sealed-pack-fieldset').forEach(function (fs) {
      var labels = [].slice.call(fs.querySelectorAll('label.sealed-pack-label'));
      if (!labels.length) return;
      labels.forEach(function (l) { l.classList.remove('sealed-ribbon-popular', 'sealed-ribbon-best'); });
      var maxQty = 0, maxLabel = null;
      labels.forEach(function (l) {
        var q = parseInt(l.dataset.sealedQty || '1', 10);
        if (q > maxQty) { maxQty = q; maxLabel = l; }
      });
      if (maxLabel) maxLabel.classList.add('sealed-ribbon-best');
      if (labels.length >= 3) {
        /* middle option = most popular */
        var mid = labels[1];
        if (mid && mid !== maxLabel) mid.classList.add('sealed-ribbon-popular');
      } else if (labels.length === 2) {
        if (labels[0] !== maxLabel) labels[0].classList.add('sealed-ribbon-popular');
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; decorate(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  setTimeout(decorate, 300);
  setTimeout(decorate, 900);
  setTimeout(decorate, 2000);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
